import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { userRole_proctorLead } from '../../../Common/appConstant';
import { AppGlobals } from '../../../Common/Services/app.global';
import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { SharedService } from './../../../Common/Services/shared.service';
import { Utility } from './../../../Common/Services/utility';
import { AdmManageProctorTeamLeadService } from './../adm-manage-proctor-team-lead.service';
import { AdmUpdateProctorTeamLeadService } from './adm-update-proctor-team-lead.service';
import { AppConfig } from 'app/Common/appConfiguration';
var AdmUpdateProctorTeamLeadComponent = (function () {
    function AdmUpdateProctorTeamLeadComponent(_sharedService, _utility, _activatedRoute, _appMessage, _updateService, _appGlobal, _manageService) {
        var _this = this;
        this._sharedService = _sharedService;
        this._utility = _utility;
        this._activatedRoute = _activatedRoute;
        this._appMessage = _appMessage;
        this._updateService = _updateService;
        this._appGlobal = _appGlobal;
        this._manageService = _manageService;
        this.id = 0;
        this.showField = true;
        this.form = new FormGroup({
            firstName: new FormControl(''),
            lastName: new FormControl(''),
            userEmail: new FormControl('', [Validators.pattern(AppConfig.emailPattern)]),
            contactNumber: new FormControl('', [Validators.pattern(AppConfig.phoneNumberRegEx)]),
            rhId: new FormControl('', Validators.required),
            maxSession: new FormControl('', [Validators.required, Validators.pattern(AppConfig.onlyNumericRegEx)]),
            officeId: new FormControl('', Validators.required),
            groupId: new FormControl('', Validators.required),
            islead: new FormControl('', Validators.required),
        });
        this.checkPermission();
        this.pageConfig = {
            title: 'Add Proctor',
            isSaveDisable: false,
            isEditDisable: true,
            isRetireDisable: true,
            isActiveDisable: true
        };
        this.form.valueChanges
            .debounceTime(400)
            .subscribe(function (form) {
            if (!_this.form.disabled && _this.form.dirty) {
                _this._utility.setTxnStatus(true); // display confirm box for FORM changes
            }
        });
    }
    AdmUpdateProctorTeamLeadComponent.prototype.ngOnInit = function () {
        this._appGlobal.routeWithID = false;
        this._utility.setDataInComboField('office', null, this.form.controls.officeId, this);
        //this.officeOptions = this._manageService.officeList;
        this.groupOptions = this._manageService.groupList;
        this.proctorLeadOptions = this._manageService.proctorLeadList;
        this.id = this._activatedRoute.snapshot.params["id"];
        if (this.id > 0) {
            this.pageConfig.title = 'Edit Proctor';
            this.pageConfig.isEditDisable = false;
            this.pageConfig.isSaveDisable = true;
            this.getProctorDetail();
        }
    };
    AdmUpdateProctorTeamLeadComponent.prototype.checkPermission = function () {
        this.role = this._appGlobal.userInfo.getValue().userRole;
        if (this.role && this.role == userRole_proctorLead) {
            this.showField = false;
            this.form.controls.islead.setValue({ value: 1 });
            this.redirectUrl = 'AdmManageProctors';
        }
        else {
            this.showField = true;
            this.redirectUrl = 'AdmManageProctorTeamLead';
        }
    };
    AdmUpdateProctorTeamLeadComponent.prototype.getProctorDetail = function () {
        var _this = this;
        this._utility.addLoaderCount();
        this._updateService.getDataById(this.id).subscribe(function (response) {
            _this._utility.onSuccessCallback(response, null, function () {
                if (response && response.response) {
                    var data_1 = response.response.results[0];
                    // disable edit feature if user is retired
                    if (data_1.isDeleted) {
                        _this.pageConfig.isActiveDisable = false;
                        _this.pageConfig.isRetireDisable = true;
                        _this.pageConfig.isEditDisable = true;
                    }
                    else {
                        _this.pageConfig.isActiveDisable = true;
                        _this.pageConfig.isRetireDisable = false;
                        _this.pageConfig.isEditDisable = false;
                    }
                    var islead = _this.proctorLeadOptions.find(function (elm) { return elm.value == data_1.islead; });
                    data_1.groupId = _this.getselectedGroupData(data_1);
                    data_1.islead = islead;
                    var finalData = _this._utility.manageFormComboData(data_1);
                    if (finalData) {
                        _this.form.patchValue(finalData);
                    }
                    _this._utility.disableEnableForm(_this.form, true);
                }
            });
        }, function (error) { return _this._utility.onErrorCallback(error); });
    };
    AdmUpdateProctorTeamLeadComponent.prototype.getselectedGroupData = function (data) {
        var selectedGroup = [];
        var _loop_1 = function (i) {
            this_1.groupOptions.filter(function (elm) {
                if (elm.id == data.groupId[i]) {
                    selectedGroup.push(elm);
                }
            });
        };
        var this_1 = this;
        for (var i = 0; i < data.groupId.length; i++) {
            _loop_1(i);
        }
        return selectedGroup;
    };
    AdmUpdateProctorTeamLeadComponent.prototype.onSave = function () {
        var _this = this;
        if (this.id) {
            var formValues = this.form.getRawValue();
            formValues = this._utility.manageFormDataforSave(formValues);
            formValues.id = this.id;
            formValues.islead = formValues.islead.value;
            this._utility.addLoaderCount();
            this._updateService.saveData(formValues).subscribe(function (response) {
                var msg = _this.id == 0 ? _this._appMessage.getItem['UMsg00030'] : _this._appMessage.getItem['UMsg00031'];
                _this._utility.onSuccessCallback(response, msg, function () {
                    _this.pageConfig.isSaveDisable = true;
                    _this.pageConfig.isEditDisable = false;
                    if (_this.id == 0) {
                        _this.pageConfig.isRetireDisable = false; // disable retire button after save new record
                    }
                    _this.id = response.response.id; // set new user Id
                    _this._utility.disableEnableForm(_this.form, true);
                    _this._utility.clearTxnStatus(); // close confirm box for FORM changes
                });
            }, function (error) { return _this._utility.onErrorCallback(error); });
        }
    };
    /**
     * When perform edit button action
     * make Edit button disable, save button enable, enable Form
     * Mark all fields as touched so that in case field does not have any value, it shows required field validations.
     */
    AdmUpdateProctorTeamLeadComponent.prototype.onEdit = function () {
        this.pageConfig.isEditDisable = true;
        this.pageConfig.isSaveDisable = false;
        this._utility.disableEnableForm(this.form, false);
        this.form.controls.officeId.markAsTouched();
    };
    /**
     * 0 - Active & 1 - Retire
     * @param status - It will be 0 or 1
     */
    AdmUpdateProctorTeamLeadComponent.prototype.onUpdateStatus = function (status) {
        var _this = this;
        var params = {
            id: this.id,
            proctorStatus: status
        };
        this._utility.addLoaderCount();
        this._updateService.updateStatus(params).subscribe(function (response) {
            var msg;
            if (_this.role && _this.role == userRole_proctorLead) {
                if (status == Enum.proctorTeamLead_Active) {
                    msg = _this._appMessage.getItem['UMsg00073'];
                }
                else {
                    msg = _this._appMessage.getItem['UMsg00072'];
                }
            }
            else {
                if (status == Enum.proctorTeamLead_Active) {
                    msg = _this._appMessage.getItem['UMsg00068'];
                }
                else {
                    msg = _this._appMessage.getItem['UMsg00067'];
                }
            }
            _this._utility.onSuccessCallback(response, msg, function () {
                _this._utility.disableEnableForm(_this.form, true);
                if (status == Enum.proctorTeamLead_Active) {
                    _this.pageConfig.isRetireDisable = false;
                    _this.pageConfig.isActiveDisable = true;
                    _this.pageConfig.isEditDisable = false;
                    _this.pageConfig.isSaveDisable = true;
                }
                else {
                    _this.pageConfig.isRetireDisable = true;
                    _this.pageConfig.isActiveDisable = false;
                    _this.pageConfig.isEditDisable = true;
                    _this.pageConfig.isSaveDisable = true;
                }
            });
        }, function (error) { return _this._utility.onErrorCallback(error); });
    };
    return AdmUpdateProctorTeamLeadComponent;
}());
export { AdmUpdateProctorTeamLeadComponent };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-update-proctor-team-lead/adm-update-proctor-team-lead.component.ts.pre-build-optimizer.js